import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Users } from "lucide-react";
import { http } from "@/lib/api";
import { Card } from "@/components/portal/ui";
import { money } from "@/lib/constants";

export default function Customers() {
  const [data, setData] = useState(null);
  useEffect(() => { http.get("/admin/customers").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <p className="text-[#6B665E]">Loading…</p>;

  return (
    <div>
      <div className="eyebrow text-[#8A998C] mb-1">Customer Records</div>
      <h1 className="font-display text-3xl text-[#1A1918] mb-1">Consulting Clients</h1>
      <p className="text-[#6B665E] text-sm mb-6">Real production customers only. Demo/sample and test accounts are excluded. Source: internal account + Stripe records. Open a profile to set package access (Paid / Complimentary).</p>

      <div className="flex flex-wrap gap-2 mb-6" data-testid="customers-counts">
        <span className="text-sm bg-[#1A1918] text-white rounded-full px-3 py-1.5">{data.total} customer(s)</span>
      </div>

      {data.customers.length === 0 ? (
        <Card className="p-8 text-center text-[#6B665E]" data-testid="customers-empty">
          <Users size={22} className="mx-auto mb-2 text-[#B7B1A7]" />
          AWAITING DATA — no real customers yet. Real signups (free or paid) will appear here. (All current accounts are demo/test and are excluded.)
        </Card>
      ) : (
        <Card className="p-0 overflow-x-auto" data-testid="customers-table">
          <table className="w-full text-sm min-w-[760px]">
            <thead><tr className="text-left text-[#8A998C] border-b border-[#F0ECE4] text-xs uppercase tracking-wide">
              {["Name", "Email", "Stage", "Products", "Orders", "Lifetime", "Joined", ""].map((h) => <th key={h} className="p-4 font-medium">{h}</th>)}
            </tr></thead>
            <tbody>
              {data.customers.map((c) => (
                <tr key={c.id} className="border-b border-[#F7F4EE] last:border-0" data-testid={`customer-row-${c.id}`}>
                  <td className="p-4 text-[#1A1918]">{c.name || "—"}</td>
                  <td className="p-4"><a href={`mailto:${c.email}`} className="text-[#9F634E] hover:underline flex items-center gap-1.5"><Mail size={13} /> {c.email}</a></td>
                  <td className="p-4 text-[#6B665E]">{c.stage}</td>
                  <td className="p-4 text-[#6B665E]">{c.products.length ? c.products.join(", ") : "—"}</td>
                  <td className="p-4 text-[#6B665E]">{c.orders}</td>
                  <td className="p-4 text-[#1A1918]">{money(c.lifetime)}</td>
                  <td className="p-4 text-[#8A998C]">{c.created_at ? new Date(c.created_at).toLocaleDateString() : "—"}</td>
                  <td className="p-4"><Link to={`/operator/customer/${c.id}`} data-testid={`customer-manage-${c.id}`} className="text-[#9F634E] hover:underline whitespace-nowrap">Manage access →</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
